import { connectWithStore } from '../../jsCore/utils/connectWithStore'
import { getRecommendedPosts } from '../../jsCore/store/recommendedPosts/recommendedPosts.selectors'
import { recommendedPostsCardsContainer } from './recommendedPostsCardsContainer'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { path } from '../../jsCore/utils/ua'
import { isCampaignEnabled } from '../../jsCore/config/campaignConfig'
import { dispatch } from '../../jsCore/application/appStore'
import { recomendedPostsEmbedAnalyticsAction } from '../../jsCore/organizedByType/actions/analyticsActions'
import { register } from '../../components/viewability/viewbilityTracker'
const COMPONENT_NAME = 'recommendedPostsComponent'

const mapStateTpProps = (state, props) => ({ posts: getRecommendedPosts(state) })

const RECOMMENDED_POSTS_CONFIG = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'RecommendedPosts',
  blacklistedCategories: ['sponsored'],
}

function connectToStore(component) {
  return connectWithStore(component, mapStateTpProps)
}

function getRecommendedPostsMountDetails(component) {
  return {
    name: COMPONENT_NAME,
    component: connectToStore(component),
  }
}

function mountRecommendedPosts(component) {
  return reduxMount({
    [MOUNT_POINTS.RECOMMENDED_POSTS]: getRecommendedPostsMountDetails(component),
  })
}

function addPlaceHolder(position) {
  const paragreph = document.querySelectorAll('.post-content > p')[position]
  if (paragreph !== undefined && paragreph !== null) {
    paragreph.insertAdjacentHTML('afterEnd', '<div class="recommendedPostsPlaceHolder"></div>')
  }
}

function mountCards() {
  mountRecommendedPosts(recommendedPostsCardsContainer)
  dispatch(recomendedPostsEmbedAnalyticsAction())
  register('.recommeneded_posts_cards__container')
}

function isSyndication() {
  return path.isSyndication
}

function injectCards(paragraph) {
  if (paragraph !== undefined) {
    addPlaceHolder(paragraph)
    mountCards()
  }
}

function getMiddleParagraph() {
  if (undefined !== document.querySelectorAll('.post-content > p')) {
    return parseInt(document.querySelectorAll('.post-content > p').length / 2)
  }
  return -1
}

export function initRecommendedPosts() {
  isCampaignEnabled(RECOMMENDED_POSTS_CONFIG).then(response => {
    if (response.isCampaignEnabled) {
      if (!isSyndication()) {
        injectCards(getMiddleParagraph())
      }
    }
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/recommendedPosts/recommendedPostsWithStoreContainer.js